import { getRouteApi } from '@mint/routing';

import { MP_LEVELS } from '../consts/index.js';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useChosenLevel = () => {
  const { activity, flight, mediaPlan } = routerApi.useSearch();

  if (activity) {
    return {
      level: MP_LEVELS.ACTIVITY,
      id: activity,
    };
  }

  if (flight) {
    return {
      level: MP_LEVELS.FLIGHT,
      id: flight,
    };
  }

  return {
    level: MP_LEVELS.MEDIA_PLAN,
    id: mediaPlan,
  };
};
